import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    'Authorization': `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// Get all spa packages with optional filter
export const getSpaPackages = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaPackage/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching spa packages:", error);
    throw error;
  }
};

// Save spa package (create or update)
export const saveSpaPackage = async (packageData) => {
  try {
    console.log("=== API CALL STARTED ===");
    console.log("URL:", `${BASE_URL}/api/SpaPackage/save`);
    console.log("Headers:", getAuthHeader());
    console.log("Package data being sent:", packageData);
    
    const response = await axios.post(`${BASE_URL}/api/SpaPackage/save`, packageData, {
      headers: getAuthHeader(),
    });
    
    console.log("API Response Status:", response.status);
    console.log("API Response Data:", response.data);
    
    return response.data;
  } catch (error) {
    console.error("Error saving spa package:", error);
    console.error("Error response:", error.response);
    throw error;
  }
};

// Get spa package by ID with full details including services
export const getSpaPackageById = async (packageId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaPackage/get`, { PackageId: packageId }, {
      headers: getAuthHeader(),
    });
    return response.data?.[0] || null;
  } catch (error) {
    console.error("Error fetching spa package by ID:", error);
    throw error;
  }
};

// Check billing usage for spa package
export const checkSpaPackageBillingUsage = async (packageId) => {
  try {
    console.log("Checking billing usage for packageId:", packageId);
    const response = await axios.post(
      `${BASE_URL}/api/SpaPackage/check-billing-usage`,
      packageId,
      { headers: getAuthHeader() }
    );
    console.log("Billing usage response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error checking spa package billing usage:", error);
    throw error;
  }
};

// API to export spa packages to Excel (Consolidated)
export const exportSpaPackagesToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaPackage/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SpaPackageReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting spa packages:", error);
    throw error;
  }
};

// API to export individual spa package details to Excel
export const exportSpaPackageDetailsToExcel = async (packageId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SpaPackage/export-details-excel/${packageId}`, {}, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `SpaPackageDetails_${packageId}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting spa package details:", error);
    throw error;
  }
};

// API to bulk import spa packages
export const bulkImportSpaPackages = async (spaPackagesData) => {
  try {
    console.log("API call - bulkImportSpaPackages:", spaPackagesData.length, "spa packages");
    // Send the data as a JSON array directly, not wrapped in an object
    const response = await axios.post(`${BASE_URL}/api/SpaPackage/bulk-import`, spaPackagesData, {
      headers: getAuthHeader(),
    });
    console.log("API response - bulkImportSpaPackages:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - bulkImportSpaPackages:", error);
    throw error;
  }
};
